var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"p-3"},[_vm._v("OEM Brand")]),_c('Banner'),_c('Photos'),_c('Brands',{staticClass:"m-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }